import * as actionTypes from "../actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  isMenuOpen: false,
  isNotificationOpen: false,
  isLogoutModalOpen: false,
  isItemUnderReviewModalOpen: false,
  isTermsConditionsModal: false,
  isPrivacyPolicyModal: false,
  isDeleteNotificationId: null,
  isDeleteAdvertModal: false,
  isDeleteChatModal: false,
  deleteNotificationTitle: null,
  isRepublishAdvertModal: false,
  isSwitchUserTypeModalOpen: false,
  isDeleteAccountModalOpen: false,
  providerServiceListModal: {
    activeCategoryId: null,
    isProviderServiceListOpen : false
  },
  navigateOnSuccess: null,
  switchProfile: null,
  error: null,
  loading: false,
  searchText: null,
};

// ----------- Menu Option Controller ----------- //
export const setOpenMenu = (state: any) => {
  return updateObject(state, {
    isMenuOpen: true,
  });
};

export const setCloseMenu = (state: any) => {
  return updateObject(state, {
    isMenuOpen: false,
  });
};

// ----------- Notification Modal Controller ----------- //
export const openNotificationModal = (state: any) => {
  return updateObject(state, {
    isNotificationOpen: true,
  });
};

export const closeNotificationModal = (state: any) => {
  return updateObject(state, {
    isNotificationOpen: false,
  });
};

// ----------- Logout Modal Controller ----------- //
export const openLogoutModal = (state: any) => {
  return updateObject(state, {
    isLogoutModalOpen: true,
  });
};

export const closeLogoutModal = (state: any) => {
  return updateObject(state, {
    isLogoutModalOpen: false,
  });
};

// ----------- Item Under Review Modal Controller ----------- //
export const openItemUnderReviewModal = (state: any) => {
  return updateObject(state, {
    isItemUnderReviewModalOpen: true,
  });
};

export const closeItemUnderReviewModal = (state: any) => {
  return updateObject(state, {
    isItemUnderReviewModalOpen: false,
  });
};

// --------- Terms and conditions Modal Controller --------------//
const setTermsConditionsModal = (state: any, action: any) => {
  return updateObject(state, {
    isTermsConditionsModal: action.state,
  });
};

// Search text
const updateSearchText = (state: any, action: any) => {
  return updateObject(state, {
    searchText: action.searchText,
  });
};

// ----------- Delete Notification Modal Controller ----------- //
export const openDeleteNotificationModal = (state: any, action: any) => {
  return updateObject(state, {
    isDeleteNotificationId: action.id,
  });
};

export const closeDeleteNotificationModal = (state: any) => {
  return updateObject(state, {
    isDeleteNotificationId: null,
  });
};

// Control delete advert modal
export const openDeleteAdvertModal = (state: any) => {
  return updateObject(state, {
    isDeleteAdvertModal: true,
  });
};

export const closeDeleteAdvertModal = (state: any) => {
  return updateObject(state, {
    isDeleteAdvertModal: false,
  });
};

// Control delete chat modal
export const openDeleteChatModal = (state: any, action: any) => {
  return updateObject(state, {
    isDeleteChatModal: true,
    deleteNotificationTitle: action.title,
  });
};

export const closeDeleteChatModal = (state: any) => {
  return updateObject(state, {
    isDeleteChatModal: false,
    deleteNotificationTitle: null,
  });
};

// Control republish advert modal
export const openRepublishAdvertModal = (state: any) => {
  return updateObject(state, {
    isRepublishAdvertModal: true,
  });
};

export const closeRepublishAdvertModal = (state: any) => {
  return updateObject(state, {
    isRepublishAdvertModal: false,
  });
};

// --------- Privacy policy Modal Controller --------------//
const setPrivacyModal = (state: any, action: any) => {
  return updateObject(state, {
    isPrivacyPolicyModal: action.state,
  });
};

// ----------- Switch User Type Modal Controller ----------- //
export const openSwitchUserTypeModal = (state: any, action: any) => {
  return updateObject(state, {
    isSwitchUserTypeModalOpen: true,
    navigateOnSuccess: action.navigateOnSuccess,
  });
};

export const closeSwitchUserTypeModal = (state: any) => {
  return updateObject(state, {
    isSwitchUserTypeModalOpen: false,
    navigateOnSuccess: null,
  });
};

 const setChangeProfileType = ( state: any , action: any) => {
  return updateObject(state, {
    switchProfile: action.switchProfile,
  });
};

// ----------- Delete Account Modal Controller ----------- //
export const openDeleteAccountModal = (state: any) => {
  return updateObject(state, {
    isDeleteAccountModalOpen: true,
  });
};

export const closeDeleteAccountModal = (state: any) => {
  return updateObject(state, {
    isDeleteAccountModalOpen: false,
  });
};

// ----------- Provider Service List Modal Controller ----------- //
const toggleProviderServiceListModal = (state: any, action: any) => {
  const updatedState = {
    ...state.providerServiceListModal,
    isProviderServiceListOpen: !state.providerServiceListModal.isProviderServiceListOpen,
  };

  return updateObject(state, {
    providerServiceListModal: updatedState,
  });
};

const updateDataInProviderServiceListModal = (state: any, action: any) => {
  const updatedState = {
    ...state.providerServiceListModal,
    activeCategoryId: action.activeCategory
  };

  return updateObject(state, {
    providerServiceListModal: updatedState,
  });
};

const headerReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.OPEN_HEADER_MENU:
      return setOpenMenu(state);
    case actionTypes.CLOSE_HEADER_MENU:
      return setCloseMenu(state);
    case actionTypes.OPEN_NOTIFICATION_MENU:
      return openNotificationModal(state);
    case actionTypes.CLOSE_NOTIFICATION_MENU:
      return closeNotificationModal(state);
    case actionTypes.OPEN_LOGOUT_MODAL:
      return openLogoutModal(state);
    case actionTypes.CLOSE_LOGOUT_MODAL:
      return closeLogoutModal(state);
    case actionTypes.OPEN_ITEM_UNDER_REVIEW_MODAL:
      return openItemUnderReviewModal(state);
    case actionTypes.CLOSE_ITEM_UNDER_REVIEW_MODAL:
      return closeItemUnderReviewModal(state);
    case actionTypes.TERMS_CONDITIONS_MODAL:
      return setTermsConditionsModal(state, action);
    case actionTypes.UPDATE_SEARCH_TEXT:
      return updateSearchText(state, action);
    case actionTypes.OPEN_DELETE_NOTIFICATION_MODAL:
      return openDeleteNotificationModal(state, action);
    case actionTypes.CLOSE_DELETE_NOTIFICATION_MODAL:
      return closeDeleteNotificationModal(state);
    case actionTypes.OPEN_DELETE_ADVERT_MODAL:
      return openDeleteAdvertModal(state);
    case actionTypes.CLOSE_DELETE_ADVERT_MODAL:
      return closeDeleteAdvertModal(state);
    case actionTypes.OPEN_DELETE_CHAT_MODAL:
      return openDeleteChatModal(state, action);
    case actionTypes.CLOSE_DELETE_CHAT_MODAL:
      return closeDeleteChatModal(state);
    case actionTypes.OPEN_REPUBLISH_ADVERT_MODAL:
      return openRepublishAdvertModal(state);
    case actionTypes.CLOSE_REPUBLISH_ADVERT_MODAL:
      return closeRepublishAdvertModal(state);
    case actionTypes.PRIVACY_POLICY_MODAL:
      return setPrivacyModal(state, action);
    case actionTypes.OPEN_SWITCH_USER_TYPE_MODAL:
      return openSwitchUserTypeModal(state, action);
    case actionTypes.CLOSE_SWITCH_USER_TYPE_MODAL:
      return closeSwitchUserTypeModal(state);
    case actionTypes.SET_CHANGE_PROFILE_TYPE:
      return setChangeProfileType(state, action);
    case actionTypes.OPEN_DELETE_ACCOUNT_MODAL:
      return openDeleteAccountModal(state);
    case actionTypes.CLOSE_DELETE_ACCOUNT_MODAL:
      return closeDeleteAccountModal(state);
    case actionTypes.TOGGLE_PROVIDER_SERVICE_MODAL:
      return toggleProviderServiceListModal(state, action);
    case actionTypes.UPDATE_DATA_IN_PROVIDER_SERVICE_MODAL:
      return updateDataInProviderServiceListModal(state, action);
    default:
      return state;
  }
};

export default headerReducer;
